var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team-validate.hours_copy"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "loading-primary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [_c("info-component", { attrs: { message: _vm.title } })]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }